import React from 'react';
import styles from './Error.module.css';

type Props = {
  className?: string;
  children?: React.ReactNode;
};

export type ErrorProps = Omit<React.HTMLProps<HTMLDivElement>, keyof Props> & Props;

const Error = React.forwardRef<HTMLDivElement, ErrorProps>(
  ({ children, className, ...props }, ref): JSX.Element | null => {
    if (!children) return null;

    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <div {...props} ref={ref} className={`${styles.root} ${className}`}>
        {children}
      </div>
    );
  }
) as React.ForwardRefExoticComponent<ErrorProps>;

export default Error;
